// The product page's add-to-cart extras (snippets/sticky-atc.liquid): the
// pinned bar, visible only while the real button is off screen and the
// footer isn't in view (its button presses the real one), and the count in
// both buttons' labels.
(function () {
  var bar = document.querySelector('[data-sticky-atc]');
  var real = document.querySelector('.product-form__submit');
  var footer = document.querySelector('.footer');
  if (!bar || !real || !('IntersectionObserver' in window)) return;

  var button = bar.querySelector('[data-sticky-atc-button]');
  var realInView = true;
  var footerInView = false;

  function update() {
    bar.classList.toggle('is-visible', !realInView && !footerInView);
  }

  // Sold out / unavailable: the real button is disabled, so this one is too.
  function syncDisabled() {
    button.disabled = real.disabled;
  }

  bar.hidden = false;
  syncDisabled();
  new MutationObserver(syncDisabled).observe(real, { attributes: true, attributeFilter: ['disabled'] });

  // "Læg 3 i kurven" once Antal goes above 1, on both buttons, so the count
  // is confirmed right where you press. Back to the normal label at 1, and
  // left alone while the product is sold out/unavailable.
  var realLabel = real.querySelector('span');
  var qtyInput = document.querySelector('.product__info-container .quantity__input');
  var baseLabel = realLabel ? realLabel.textContent.trim() : '';
  function syncLabel() {
    if (!realLabel || real.disabled) return;
    var n = parseInt(qtyInput && qtyInput.value, 10) || 1;
    var text = n > 1 ? 'Læg ' + n + ' i kurven' : baseLabel;
    realLabel.textContent = text;
    button.textContent = text;
  }
  if (qtyInput) {
    qtyInput.addEventListener('change', syncLabel);
    qtyInput.addEventListener('input', syncLabel);
  }

  button.addEventListener('click', function () {
    real.click();
  });

  new IntersectionObserver(function (entries) {
    realInView = entries[0].isIntersecting;
    update();
  }).observe(real);

  if (footer) {
    new IntersectionObserver(function (entries) {
      footerInView = entries[0].isIntersecting;
      update();
    }).observe(footer);
  }
})();
